import * as tslib_1 from "tslib";
import { EventEmitter, OnInit, QueryList } from '@angular/core';
import { MatCheckbox, MatCheckboxChange, MatDialogRef, MatSnackBar } from '@angular/material';
import { AirportService } from '../airport.service';
import { TagService } from '../../shared/services/tag.service';
var EditCampingComponent = /** @class */ (function () {
    function EditCampingComponent(_matDialogRef, data, _airportService, _tagService, _snackBar) {
        this._matDialogRef = _matDialogRef;
        this._airportService = _airportService;
        this._tagService = _tagService;
        this._snackBar = _snackBar;
        this.disableClose = false;
        this.tags = [];
        this.isLoading = true;
        this.change = new EventEmitter();
        this.error = new EventEmitter();
        this.airport = data.airport;
    }
    EditCampingComponent.prototype.ngOnInit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var allTags, _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l;
            var _this = this;
            return tslib_1.__generator(this, function (_m) {
                switch (_m.label) {
                    case 0: return [4 /*yield*/, this._tagService.getAllTags()];
                    case 1:
                        allTags = _m.sent();
                        _a = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field')];
                    case 2:
                        _a.CampingOnFieldTag = _m.sent();
                        _b = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Year-Round')];
                    case 3:
                        _b.YearRoundTag = _m.sent();
                        _c = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Seasonal')];
                    case 4:
                        _c.SeasonalTag = _m.sent();
                        _d = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Special Events Only')];
                    case 5:
                        _d.SpecialEventTag = _m.sent();
                        _e = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Availability::Reservation Required')];
                    case 6:
                        _e.ReservationsTag = _m.sent();
                        _f = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Restrooms')];
                    case 7:
                        _f.RestroomsTag = _m.sent();
                        _g = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Showers')];
                    case 8:
                        _g.ShowersTag = _m.sent();
                        _h = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Potable Water')];
                    case 9:
                        _h.PotableWaterTag = _m.sent();
                        _j = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Food/Vending')];
                    case 10:
                        _j.FoodTag = _m.sent();
                        _k = this;
                        return [4 /*yield*/, this._tagService.findTagByName(allTags, 'Camping On Field::Facilities::Shelter')];
                    case 11:
                        _k.ShelterTag = _m.sent();
                        this.isLoading = false;
                        if (!this.isChecked(this.SeasonalTag.tagId)) return [3 /*break*/, 12];
                        this.chosenAvailability = 'Seasonal';
                        return [3 /*break*/, 16];
                    case 12:
                        if (!this.isChecked(this.SpecialEventTag.tagId)) return [3 /*break*/, 13];
                        this.chosenAvailability = 'Special Events Only';
                        return [3 /*break*/, 16];
                    case 13:
                        this.chosenAvailability = 'Year-Round';
                        if (!!this.isChecked(this.YearRoundTag.tagId)) return [3 /*break*/, 16];
                        return [4 /*yield*/, this._tagService.postAirportTag(this.YearRoundTag.tagId, this.airport.airportId)];
                    case 14:
                        _m.sent();
                        _l = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 15:
                        _l.airport = _m.sent();
                        _m.label = 16;
                    case 16:
                        this._matDialogRef.backdropClick().subscribe(function () {
                            _this.close();
                        });
                        return [2 /*return*/];
                }
            });
        });
    };
    EditCampingComponent.prototype.isChecked = function (tagId) {
        var TAGS = this.airport.airportTags;
        for (var _i = 0, TAGS_1 = TAGS; _i < TAGS_1.length; _i++) {
            var tag = TAGS_1[_i];
            if (tag.tagId === tagId) {
                return true;
            }
        }
        return false;
    };
    EditCampingComponent.prototype.checkBoxChanged = function (event) {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var TAG_ID, _a, e_1;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        TAG_ID = +event.source.id;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 7, , 8]);
                        if (!event.source.checked) return [3 /*break*/, 3];
                        return [4 /*yield*/, this._tagService.postAirportTag(TAG_ID, this.airport.airportId)];
                    case 2:
                        _b.sent();
                        this.change.emit();
                        return [3 /*break*/, 5];
                    case 3: return [4 /*yield*/, this._tagService.deleteAirportTag(TAG_ID, this.airport.airportId)];
                    case 4:
                        _b.sent();
                        this.change.emit();
                        _b.label = 5;
                    case 5:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 6:
                        _a.airport = _b.sent();
                        return [3 /*break*/, 8];
                    case 7:
                        e_1 = _b.sent();
                        this.error.emit(new Error('API Call Failed'));
                        return [3 /*break*/, 8];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    EditCampingComponent.prototype.availabilityChanged = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!(this.chosenAvailability === 'Special Events Only')) return [3 /*break*/, 7];
                        if (!this.isChecked(this.YearRoundTag.tagId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.YearRoundTag.tagId, this.airport.airportId)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!this.isChecked(this.SeasonalTag.tagId)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.SeasonalTag.tagId, this.airport.airportId)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        if (!!this.isChecked(this.SpecialEventTag.tagId)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._tagService.postAirportTag(this.SpecialEventTag.tagId, this.airport.airportId)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6: return [3 /*break*/, 20];
                    case 7:
                        if (!(this.chosenAvailability === 'Seasonal')) return [3 /*break*/, 14];
                        if (!this.isChecked(this.YearRoundTag.tagId)) return [3 /*break*/, 9];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.YearRoundTag.tagId, this.airport.airportId)];
                    case 8:
                        _b.sent();
                        _b.label = 9;
                    case 9:
                        if (!!this.isChecked(this.SeasonalTag.tagId)) return [3 /*break*/, 11];
                        return [4 /*yield*/, this._tagService.postAirportTag(this.SeasonalTag.tagId, this.airport.airportId)];
                    case 10:
                        _b.sent();
                        _b.label = 11;
                    case 11:
                        if (!this.isChecked(this.SpecialEventTag.tagId)) return [3 /*break*/, 13];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.SpecialEventTag.tagId, this.airport.airportId)];
                    case 12:
                        _b.sent();
                        _b.label = 13;
                    case 13: return [3 /*break*/, 20];
                    case 14:
                        if (!!this.isChecked(this.YearRoundTag.tagId)) return [3 /*break*/, 16];
                        return [4 /*yield*/, this._tagService.postAirportTag(this.YearRoundTag.tagId, this.airport.airportId)];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        if (!this.isChecked(this.SeasonalTag.tagId)) return [3 /*break*/, 18];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.SeasonalTag.tagId, this.airport.airportId)];
                    case 17:
                        _b.sent();
                        _b.label = 18;
                    case 18:
                        if (!this.isChecked(this.SpecialEventTag.tagId)) return [3 /*break*/, 20];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.SpecialEventTag.tagId, this.airport.airportId)];
                    case 19:
                        _b.sent();
                        _b.label = 20;
                    case 20:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 21:
                        _a.airport = _b.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    EditCampingComponent.prototype.close = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var _a;
            return tslib_1.__generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        if (!this.airport) return [3 /*break*/, 21];
                        if (!!this.isChecked(this.CampingOnFieldTag.tagId)) return [3 /*break*/, 20];
                        if (!this.isChecked(this.YearRoundTag.tagId)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.YearRoundTag.tagId, this.airport.airportId)];
                    case 1:
                        _b.sent();
                        _b.label = 2;
                    case 2:
                        if (!this.isChecked(this.SeasonalTag.tagId)) return [3 /*break*/, 4];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.SeasonalTag.tagId, this.airport.airportId)];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        if (!this.isChecked(this.SpecialEventTag.tagId)) return [3 /*break*/, 6];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.SpecialEventTag.tagId, this.airport.airportId)];
                    case 5:
                        _b.sent();
                        _b.label = 6;
                    case 6:
                        if (!this.isChecked(this.ReservationsTag.tagId)) return [3 /*break*/, 8];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.ReservationsTag.tagId, this.airport.airportId)];
                    case 7:
                        _b.sent();
                        _b.label = 8;
                    case 8:
                        if (!this.isChecked(this.RestroomsTag.tagId)) return [3 /*break*/, 10];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.RestroomsTag.tagId, this.airport.airportId)];
                    case 9:
                        _b.sent();
                        _b.label = 10;
                    case 10:
                        if (!this.isChecked(this.ShowersTag.tagId)) return [3 /*break*/, 12];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.ShowersTag.tagId, this.airport.airportId)];
                    case 11:
                        _b.sent();
                        _b.label = 12;
                    case 12:
                        if (!this.isChecked(this.PotableWaterTag.tagId)) return [3 /*break*/, 14];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.PotableWaterTag.tagId, this.airport.airportId)];
                    case 13:
                        _b.sent();
                        _b.label = 14;
                    case 14:
                        if (!this.isChecked(this.FoodTag.tagId)) return [3 /*break*/, 16];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.FoodTag.tagId, this.airport.airportId)];
                    case 15:
                        _b.sent();
                        _b.label = 16;
                    case 16:
                        if (!this.isChecked(this.ShelterTag.tagId)) return [3 /*break*/, 18];
                        return [4 /*yield*/, this._tagService.deleteAirportTag(this.ShelterTag.tagId, this.airport.airportId)];
                    case 17:
                        _b.sent();
                        _b.label = 18;
                    case 18:
                        _a = this;
                        return [4 /*yield*/, this._airportService.getAirport(this.airport.identifier, true)];
                    case 19:
                        _a.airport = _b.sent();
                        _b.label = 20;
                    case 20:
                        this._matDialogRef.close(true);
                        _b.label = 21;
                    case 21: return [2 /*return*/];
                }
            });
        });
    };
    EditCampingComponent.prototype.handleError = function () {
        this._matDialogRef.close(false);
    };
    return EditCampingComponent;
}());
export { EditCampingComponent };
